import {
  gerPortadaActuacion as getPA,
  getArbolFromElectronico,
  getArbolPenalLaboral,
  getPortadaCarpeta as getPC,
  gerPortadaCarpetaJudicial as getPCJ,
  getIsArchivado as getIA,
  postIsArchivado as postIA,
} from "services/expedientesAutorizados/expedientesAutorizadosServices";
import tribunalAPI from "../api/tribunalAPi";
import { electronicoPeritosAPI } from "../api/tribunalAPi";
import { BodyDocumentosDeActuacion } from "interfaces/actuacionPDFservice/actuacionPDFServiceInterfaces";
import {
  addListFilesPenalDemandado,
  onAddNodoSelected,
  onAddPortadaPenalLaboral,
  onChangeIsCentral,
  onChangeIsRegresar,
  onIsErrorGetPortada,
  onLoadPenalAdolscente,
  onLoadTokenData,
  onLoadVideoAudiencia,
  onLoadVideoInfo,
  onResetStatePortadas,
  onResetVideoAudiencia,
  onSearchExpedientes,
  onSelectActuacion,
  onSelectVideo,
  onSelectVideoAud,
  onSetExpediente,
  onAddLstArbol,
  onSetCurrentPortada,
  onSetDatosContext,
  onAddRutaPdf,
  onSetDetallesPortada,
  onResetDeralles,
  onSetDetallesPortadaExhortos,
  onSetCveSistemaMateria,
  onSetArchivado,
  onSetFiltrosChecked,
  onLoadingArchivar,
  onResetChecks,
  onSetLstExpedientes,
  onSetDatosCaratula,
} from "store/expediente/expedienteSlice";
import { useAppDispatch, useAppSelector } from "./reduxHooks";
import {
  BodyHistorialRegistros,
  Imagenes,
} from "interfaces/expedientes/expedientesInterface";
import {
  useGetActuacionesBySistemaMutation,
  usePostHistorialRegistrosMutation,
} from "services/expedienteElectronico/expedienteElectronico";
import {
  getDetalleVideoAudiencia,
  getTokenVideoLaboral,
  getVideoAudienciaService,
  sendFormTerminosYCondiciones,
} from "services/videoAudiencia/videoAudienciaService";
import {
  RequestTokenLaboral,
  SolicitudVideoAudienciaDetalle,
} from "interfaces/videoAudiencia/videoAudienciaInterface";
import {
  onLoadConversionActuacion,
  onLoadLiberacionActuacion,
} from "store/audioActuaciones/audioActuacionSlice";//eslint-disable-next-line
import { useAudioActuaciones } from "hooks/useAudioActuaciones";
import Swal from "sweetalert2";
import { useVisorDocumentosStore } from "./useVisorDocumentosStore";
import { useSearchParams } from "react-router-dom";
import {
  TiposLaboral,
  CveTiposDocumentosLaboral,
  TiposPenal,
  CveTipoDocumentoPenal,
} from "../static/_equivalenciasCarpetasExlabPenal";
import { setIsLoading } from "store";

export const useExpediente = () => {
  const expedienteState = useAppSelector((state) => state.expediente);
  let [searchParams] = useSearchParams();
  const {
    nodoSelected,
    videoAudiencia,
    showVideo,
    actuacion,
    bodyRequest,
    tokenData,
    infoVideo,
    isSearch,
    penalAdolescente,
    isCentral,
    isRegresar,
    posExpediente,
    lstArbol,
    currentPortada,
    portadaCarpeta,
    datosContext,
    rutaPdf,
    detallesCarpeta,
    cveSistemaMateria,
    isArchivado,
    filtosChecked,
    loadingArchivar,
    resertChecks,
    lstExpedientes,
    datosCaratula,
  } = useAppSelector((state) => state.expediente);

  const { addPosicionLaboral, addPosicionPenal, addDocumentoSeleccionado } = useVisorDocumentosStore();
  const dispatch = useAppDispatch();

  const [getActuacionesBySistema, response] =
    useGetActuacionesBySistemaMutation();
  const [postHistorialRegistros, responseHistorialRegistros] =
    usePostHistorialRegistrosMutation();

  const { startGetLiberacionActuacion } = useAudioActuaciones();

  const getPortadaCarpeta = async (idCarpetaJudicial: number) => {
    const portadaC = await getPC(idCarpetaJudicial);
    dispatch({
      type: "expediente/setPortadaCarpeta",
      payload: portadaC,
    });
    setProperties({
      cveTipoActuacionSelected: 0,
      currentPortada: portadaC,
    });
  };

  const getPortadaActuacion = async (
    idActuacion: number,
    cveTipoActuacion: number
  ) => {
    let
      portadaA = await getPA(idActuacion, cveTipoActuacion);
    dispatch({
      type: "expediente/pushPortadaActuacion",
      payload: portadaA,
    });


    setProperties({
      cveTipoActuacionSelected: cveTipoActuacion,
      currentPortada: portadaA,
    });

    // limpiar redux de audio actuaciones conversion y liberacion
    dispatch(onLoadConversionActuacion(null));
    dispatch(onLoadLiberacionActuacion(null));
    startGetLiberacionActuacion({ cveTipoActuacion: cveTipoActuacion, idActuacion: idActuacion });
  };
  const startGetportadaCarpetaJudicialExhortos = (idCarpetaJudicial: number) => {
    dispatch(onSetDetallesPortada([]));
    dispatch(onSetDatosCaratula([]));
    dispatch(setIsLoading(true));
    getPCJ(idCarpetaJudicial)
      .then(({ data }) => {
        dispatch(onSetDatosCaratula(data?.data));
        dispatch(onSetDetallesPortadaExhortos(data?.data));
        dispatch(onSetDetallesPortada(data?.data));
        dispatch(setIsLoading(false));
      })
      .catch((err) => {
        dispatch(onSetDetallesPortada([]));
        dispatch(onSetDatosCaratula([]));
        console.log(err);
        dispatch(setIsLoading(false));
      });
  };

  const setProperties = (properties: object) => {
    dispatch({
      type: "expediente/setProperties",
      payload: properties,
    });
  };

  const setCurrentPortada = (currentCarpeta: any) => {
    dispatch({
      type: "expediente/setProperties",
      payload: { currentCarpeta },
    });
  };

  const actuacionSelectedIs = (cveTipoActuacion: number) => {
    return expedienteState.cveTipoActuacionSelected === cveTipoActuacion;
  };

  const getNameForCurrentPortada = () => {
    return (
      {
        0: "Expediente",
        1: "Promoción",
        2: "Acuerdo",
        3: "Sentencia",
        4: "Certificacion",
        5: "Oficio",
        6: "Notificación",
        7: "Diligencia",
        9: "Promoción de termino",
        14: "Audiencia",
        21: "Remisión de apelación",
      }[expedienteState.cveTipoActuacionSelected] ?? "Sin nombre"
    );
  };

  const getDocumentoService = async (params: any): Promise<any> => {
    const url = "/expedientes-autorizados/imagenes";
    const responseData = (await tribunalAPI.get(url, { params }));
    return responseData;
  }

  const getDocumentosCarpetaActuacion = async (value: any) => {
    setRutaPdf(null)
    let request: any = {};

    if (value?.cveTipoActuacion === 0 || value?.cveTipoActuacion === null) {
      request.idCarpetaJudicial =
        value?.referenciaId;
    } else if (value?.cveTipoActuacion !== 14) {
      request.idActuacion = value?.referenciaId;
    } else if (value?.cveTipoActuacion === 14) {
      request.idAudiencia = value?.referenciaId;
    }
    let backURL: string = process.env.REACT_APP_BACKEND_URL as string;
    backURL = backURL[backURL.length - 1] !== "/" ? backURL + "/" : backURL;
    return getDocumentoService(request).then(({ data }) => {

      if (data?.data?.length) {
        return data?.data?.map((imagen: any) => {
          return `${backURL}expedientes-autorizados/get-imagen?ruta=` + encodeURIComponent(imagen.ruta);
        });
      } else {
        Swal.fire({
          title: "Error",
          text: "El documento no cuenta con imágenes.",
          icon: "warning",
        });
      }
    }).catch((err) => {
      console.log(err)

      if (err?.response?.status === 404) {
        const tipoActuacionInvalida = value?.cveTipoActuacion === 0 || value?.cveTipoActuacion == null;

        if (!tipoActuacionInvalida) {
          Swal.fire({
            title: "Advertencia",
            text: "La actuación no cuenta con imágenes digitalizadas a mostrar.",
            icon: "warning",
          });
        }

      } else {
        Swal.fire({
          title: "Error",
          text: "Hubo un problema para obtener las imágenes del documento.",
          icon: "warning",
        });
      }
    })
  };




  const getDocumentosPeritos = async (idCarpeta: number) => {
    return (
      await electronicoPeritosAPI.get("acuse-notificacion-perito/" + idCarpeta, {
        responseType: "arraybuffer",
      })
    )
  };

  const getArbol = async (idExpediente: number, arbolType: string) => {
    if (arbolType === "electronico") {
      return getArbolFromElectronico(idExpediente);
    }

    return getArbolPenalLaboral(idExpediente, arbolType);
  };

  const startGetDocumentosActuacionesPorSistema = (
    params: BodyDocumentosDeActuacion
  ) => {
    //console.log("Params.tipo: ", params.tipo, "Params.cveTipoDoc: ", params.cveTipoDoc, "Params.idDocumento: ", params.idDocumento);
    getActuacionesBySistema({
      cveSistema: params.cveSistema,
      idDocumento: params.idDocumento,
      tipo: params.tipo,
      cveTipoDoc: params.cveTipoDoc,
      queEs: params.queEs,
      "consulta[idReferencia]": params.idReferencia,
      "consulta[cveMateria]": params.materia,
      "consulta[cveDocumento]": params.cveDocumento,
      "consulta[cveTarifa]": params.cveTarifa,
    })
      .unwrap()
      .then(({ data }) => {
        const listFiles = data.imagenes?.imagenes?.data.length
          ? data.imagenes?.imagenes?.data.map((images) => images.img)
          : data.imagenes?.data?.length
            ? data.imagenes?.data?.map((images) => images.img)
            : [];
        /**@ts-ignore */
        if (data.imagenes.caratula?.length) {
          isErrorGetPortada(true);
          return;
        }
        if (typeof data?.imagenes.imagenes?.message === "string") {
          isErrorGetPortada(true);
          return;
        }
        addListFiles(listFiles);
        isErrorGetPortada(false);
        response.reset();
      })
      .catch((err) => {
        isErrorGetPortada(true);
        console.log(err);
      });
  };



  const startGetDocumentosActuacionesPenal = (
    params: any
  ) => {

    let tipoCarpeta = searchParams?.get("tipoCarpeta") ?? "";
    let cveTipoDocLaboral = CveTiposDocumentosLaboral[tipoCarpeta];
    return getActuacionesBySistema({
      cveSistema:
        searchParams.get("arbol") === "penal"
          ? 38
          : searchParams.get("arbol") === "adolescente"
            ? 43
            : 68,
      idDocumento:
        params.li_attr.TipoArchivo === "CARPETA"
          ? Number(params.li_attr.dataidCarpetaJudicial)
          : params.li_attr.TipoArchivo === "AUDIENCIA"
            ? Number(params.li_attr.dataActuacionName)
            : Number(params.li_attr.dataidActuacion),
      tipo:
        searchParams.get("arbol") !== "laboral"
          ? TiposPenal[params.li_attr.TipoArchivo]
          : TiposLaboral[params.li_attr.TipoArchivo],
      cveTipoDoc:
        searchParams.get("arbol") !== "laboral"
          ? CveTipoDocumentoPenal["GENERAL"]
          : cveTipoDocLaboral ?? CveTiposDocumentosLaboral.ACTUACIONES_GENERAL,
      queEs: 2,
      "consulta[idReferencia]":
        params.li_attr.TipoArchivo === "CARPETA"
          ? Number(params.li_attr.dataidCarpetaJudicial)
          : params.li_attr.TipoArchivo === "AUDIENCIA"
            ? Number(params.li_attr.dataActuacionName)
            : Number(params.li_attr.dataidActuacion),
      "consulta[cveMateria]": searchParams.get("arbol") === "penal" ? 3 : 8,
      "consulta[cveDocumento]":
        params.cveTipoActuacion === null
          ? 2
          : params.cveTipoActuacion === 14
            ? 4
            : 1,
      "consulta[cveTarifa]": 1,
    })
  };


  const startGetDocumentosActuaciones = (
    params: BodyDocumentosDeActuacion,
    tipo: string
  ) => {
    console.log("Params.tipo: ", params.tipo, "Params.cveTipoDoc: ", params.cveTipoDoc, "Params.idDocumento: ", params.idDocumento);
    getActuacionesBySistema({
      cveSistema: params.cveSistema,
      idDocumento: params.idDocumento,
      tipo: params.tipo,
      cveTipoDoc: params.cveTipoDoc,
      queEs: params.queEs,
      "consulta[idReferencia]": params.idReferencia,
      "consulta[cveMateria]": params.materia,
      "consulta[cveDocumento]": params.cveDocumento,
      "consulta[cveTarifa]": params.cveTarifa,
    })
      .unwrap()
      .then(({ data }) => {
        const listFiles = data.imagenes?.imagenes?.data.length
          ? data.imagenes?.imagenes?.data.map((images) => images.img)
          : data.imagenes?.data?.length
            ? data.imagenes?.data?.map((images) => images.img)
            : [];
        const dataList = data?.imagenes?.imagenes
          ? data.imagenes?.imagenes
          : data?.imagenes;

        /**@ts-ignore */
        if (data.imagenes.caratula?.length) {
          isErrorGetPortada(true);
          return;
        }
        if (typeof data?.imagenes.imagenes?.message === "string") {
          isErrorGetPortada(true);
          return;
        }
        addCaratulaInfoPenalLaboral(dataList);
        addListFiles(listFiles);
        if (tipo === "anterior") {
          addPosicionLaboral(listFiles.length - 1);
          addPosicionPenal(listFiles.length - 1)
          addDocumentoSeleccionado(listFiles[listFiles.length - 1])
        } else {
          addPosicionLaboral(0);
          addPosicionPenal(0);
          addDocumentoSeleccionado(listFiles[0])
        }
        isErrorGetPortada(false);
        response.reset();
      })
      .catch((err) => {
        isErrorGetPortada(true);
        console.log(err);
      });
  };
  const startPostHistorialRegistros = (body: BodyHistorialRegistros) => {
    postHistorialRegistros(body)
      .unwrap()
      .then(({ data }) => {
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const addCaratulaInfoPenalLaboral = (data: any) =>
    dispatch(onAddPortadaPenalLaboral(data));
  const addListFiles = (listPDFS: string[]) =>
    dispatch(addListFilesPenalDemandado(listPDFS));
  const resetStatePortadas = () => dispatch(onResetStatePortadas());
  const isErrorGetPortada = (status: boolean) =>
    dispatch(onIsErrorGetPortada(status));
  const addNodoSelected = (title: string) => dispatch(onAddNodoSelected(title));
  const onResetVideo = () => dispatch(onResetVideoAudiencia());
  const startGetVideoAudiencia = (value: SolicitudVideoAudienciaDetalle) => {
    getDetalleVideoAudiencia(value)
      .then(({ data }) => {
        dispatch(onLoadVideoAudiencia(data?.data));
      })
      .catch((err) => {
        dispatch(onLoadVideoAudiencia(null));
        console.log(err);
      });
  };
  const startGetVideoAudienciaStreaming = async (tokenRecibido: any) => {
    let body = {
      token: tokenRecibido,
    };
    getVideoAudienciaService(body)
      .then(({ data }) => {
        setInfoVideo(data);
      })
      .catch((error) => {
        setInfoVideo(null);
      });
  };
  const startSendDataTerminos = async (data: any, url: string) => {
    sendFormTerminosYCondiciones(data, url)
      .then(() => {
        Swal.fire({
          title: "Términos y Condiciones",
          text: `Si ya has aceptado los términos y condiciones, te recomendamos hacer clic en el botón "Continuar" para poder visualizar el video.`,
          icon: "info",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Continuar",
          showCloseButton: false,
        }).then((result) => {
          if (result.isConfirmed) {
            startGetVideoAudiencia(bodyRequest);
          }
        });
      })
      .catch((error) => {
        Swal.fire({
          title: "Términos y Condiciones",
          text: `Ocurrió un problema al enviar los datos, contactese con soporte`,
          icon: "info",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Aceptar",
          showCloseButton: false,
        });
        console.log(error);
      });
  };

  const startGetToken = (params: RequestTokenLaboral) => {
    getTokenVideoLaboral(params)
      .then(({ data }) => {
        dispatch(onLoadTokenData(data?.data));
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getExpIsArchivado = async (idCarpetaJudicial: number, cveSistema: number) => {
    setArchivado([]);
    getIA(idCarpetaJudicial, cveSistema)
      .then(({ data }) => {
        setArchivado(data?.data);
      })
      .catch((error) => {
        console.log(error);
        if (error?.response?.data?.status === "error") {
          setArchivado([]);
        } else {
          setArchivado(null);
        }
      });
  };

  const postArchivarExpediente = async (idCarpetaJudicial: number, cveSistema: number, archivar: string) => {
    setLoadingArchivar(true);
    postIA(idCarpetaJudicial, cveSistema, archivar)
      .then(({ data }) => {
        setArchivado([]);
        setLoadingArchivar(false);
        Swal.fire({
          title: "Correcto",
          text: `El expediente ha sido ${archivar === "S" ? "archivado" : "desarchivado"} correctamente`,
          icon: "success",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Aceptar",
          showCloseButton: false,
        });
        setArchivado(data?.data);
      })
      .catch((error) => {
        setArchivado(null);
        setLoadingArchivar(false);
        Swal.fire({
          title: "Error",
          text: `Hubo un problema al ${archivar === "S" ? "archivar" : "desarchivar"} el expediente.`,
          icon: "error",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Aceptar",
          showCloseButton: false,
        });
        console.log(error);
      });
  };


  const onAddLstArbolRec = (value: []) => dispatch(onAddLstArbol(value))
  const canViewVideo = (value: boolean) => dispatch(onSelectVideo(value));
  const selectActuacion = (value: any) => dispatch(onSelectActuacion(value));
  const setRequest = (value: any) => dispatch(onSelectVideoAud(value));
  const setInfoVideo = (value: any) => dispatch(onLoadVideoInfo(value));
  const setSearch = (value: boolean) => dispatch(onSearchExpedientes(value));
  const setIsCentral = (value: boolean) => dispatch(onChangeIsCentral(value));
  const setIsRegresar = (value: boolean) => dispatch(onChangeIsRegresar(value));
  const setPosExp = (value: any) => dispatch(onSetExpediente(value));
  const setPenalAdolescente = (value: string) =>
    dispatch(onLoadPenalAdolscente(value));

  const setCurrentPortadaActual = (value: any) => dispatch(onSetCurrentPortada(value));
  const setDatosContext = (value: any) => dispatch(onSetDatosContext(value));
  const setRutaPdf = (value: any) => dispatch(onAddRutaPdf(value));

  const setDetallesPortada = (value: any) => dispatch(onSetDetallesPortada(value));
  const setResetDetallesP = () => dispatch(onResetDeralles());
  const setCveSistemaMateria = (value: number) => dispatch(onSetCveSistemaMateria(value));
  const setArchivado = (value: [] | null) => dispatch(onSetArchivado(value));
  const setFiltrosChecked = (value: any) => dispatch(onSetFiltrosChecked(value));
  const setLoadingArchivar = (value: boolean) => dispatch(onLoadingArchivar(value));
  const setResetChecks = (value: boolean) => dispatch(onResetChecks(value));
  const setLstExpedinetes = (value: any[]) => dispatch(onSetLstExpedientes(value));

  return {
    portadaCarpeta,
    currentPortada,
    cveTipoActuacionSelected: expedienteState.cveTipoActuacionSelected,
    portadaPenalLaboral: expedienteState.portadaPenalLaboral,
    listFiles: expedienteState.listFiles,
    isErrorPortada: expedienteState.isErrorPortada,
    response,
    responseHistorialRegistros,
    nodoSelected,
    videoAudiencia,
    showVideo,
    actuacion,
    bodyRequest,
    tokenData,
    infoVideo,
    isSearch,
    penalAdolescente,
    isCentral,
    isRegresar,
    posExpediente,
    lstArbol,
    datosContext,
    rutaPdf,
    detallesCarpeta,
    cveSistemaMateria,
    isArchivado,
    filtosChecked,
    loadingArchivar,
    resertChecks,
    lstExpedientes,
    datosCaratula,
    dispatch,
    getPortadaCarpeta,
    getPortadaActuacion,
    setProperties,
    setCurrentPortada,
    actuacionSelectedIs,
    getNameForCurrentPortada,
    getDocumentosCarpetaActuacion,
    getDocumentosPeritos,
    getArbol,
    startGetDocumentosActuacionesPorSistema,
    startGetDocumentosActuaciones,
    addCaratulaInfoPenalLaboral,
    addListFiles,
    resetStatePortadas,
    isErrorGetPortada,
    startPostHistorialRegistros,
    addNodoSelected,
    startGetVideoAudiencia,
    canViewVideo,
    selectActuacion,
    onResetVideo,
    setRequest,
    startGetToken,
    setInfoVideo,
    startGetVideoAudienciaStreaming,
    startSendDataTerminos,
    setSearch,
    setPenalAdolescente,
    setIsCentral,
    setIsRegresar,
    setPosExp,
    onAddLstArbolRec,
    setCurrentPortadaActual,
    setDatosContext,
    setRutaPdf,
    startGetDocumentosActuacionesPenal,
    setDetallesPortada,
    setResetDetallesP,
    startGetportadaCarpetaJudicialExhortos,
    getExpIsArchivado,
    setCveSistemaMateria,
    setArchivado,
    postArchivarExpediente,
    setFiltrosChecked,
    setLoadingArchivar,
    setResetChecks,
    setLstExpedinetes,
  };
};
